<template>
    <Modal v-model="modalCreate"
           :title="$t(title+'安全组规则')"
           width="870"
           class="securitygroup-form"
           :mask-closable="false"
           @on-cancel="closeModal">
        <div class="rules-header">
            <div class="header-left">
                <div class="header-title">{{$t('定制规则')}}</div>
                <div>
                    <div class="rule-item"
                         v-for="item in rule.custom"
                         :key="item.id"
                         @click='changeSelectRule(item)'
                         :class="selectRule.name ===item.name?'active':''">{{item.name}}</div>
                </div>
            </div>
            <div class="header-right">
                <div class="header-title">{{$t('其他协议')}}</div>
                <div>
                    <div class="rule-item"
                         v-for="item in rule.other"
                         :key="item.id"
                         @click='changeSelectRule(item)'
                         :class="selectRule.name===item.name?'active':''">{{item.name}}</div>
                </div>
            </div>
        </div>

        <Form ref="createForm"
              :model="formData"
              class="create-form"
              :rules="ruleForm"
              :label-width="120">
            <FormItem :label="`${$t('方向')}:`">
                <label class="form-item">{{Credirection==="ingress"?$t('入方向'):$t('出方向')}}</label>
            </FormItem>
            <FormItem :label="`${$t('起始端口号')}:`"
                      class="form-label"
                      prop="fromPorts"
                      v-if="selectRule && !selectRule.portRange">
                <InputNumber :max="selectRule.ipProtocol=='ICMP'?255:65535"
                             :min="selectRule.ipProtocol=='ICMP'?0:1"
                             class="form-item"
                             v-model="formData.fromPorts"></InputNumber>
                <!--ICMP的端口范围是0-255其他的是1-65535 fixed bug 9050 by lcj-->
                <Poptip trigger="hover"
                        placement="right"
                        :content="selectRule.ipProtocol=='ICMP'? $t('端口范围') + '0~255':$t('端口范围') + '1~65535'">
                    <i class="icon-prompt-1-o tips-style"
                       style="color:#2d8cf0"></i>
                </Poptip>
                <p v-if="startPort"
                   style="color:#ed4014">{{$t('起始端口号不能小于1')}}</p>
            </FormItem>
            <FormItem :label="`${$t('终止端口号')}:`"
                      class="form-label"
                      prop="toPorts"
                      v-if="selectRule && !selectRule.portRange">
                <InputNumber :max="selectRule.ipProtocol=='ICMP'?255:65535"
                             :min="0"
                             class="form-item"
                             v-model="formData.toPorts"></InputNumber>
                <Poptip trigger="hover"
                        placement="right"
                        :content="selectRule.ipProtocol=='ICMP'?  $t('端口范围') + '0~255':$t('端口范围') + '2~65535'">
                    <i class="icon-prompt-1-o tips-style"
                       style="color:#2d8cf0"></i>
                </Poptip>
            </FormItem>
            <FormItem :label="`${$t('端口范围')}:`"
                      class="form-label"
                      prop="portRange"
                      v-if="selectRule && selectRule.portRange">
                <Input :max="65535"
                       :min="1"
                       :disabled="selectRule.disPortRange"
                       class="form-item"
                       :value="range"></Input>
            </FormItem>
            <FormItem :label="`${$t('授权类型')}:`"
                      class="form-label"
                      prop="authorizationType">
                <Select v-model="formData.authorizationType"
                        class="form-item">
                    <Option v-for="item in authorizeList"
                            :value="item.name"
                            :key="item.name">{{ item.name }}</Option>
                </Select>
            </FormItem>
            <FormItem :label="`${$t('安全组')}:`"
                      prop="sourceGroupId"
                      v-if="formData.authorizationType=='安全组访问'"
                      class="form-label">
                <Select v-model="formData.sourceGroupId"
                        class="form-item">
                    <Option v-for="item in securityList"
                            :value="item.uuid"
                            :key="item.uuid">{{ item.name }}</Option>
                </Select>
            </FormItem>
            <FormItem :label="`${$t('以太网类型')}:`"
                      prop="ethertype"
                      v-if="formData.authorizationType=='安全组访问'"
                      class="form-label">
                <Select v-model="formData.ethertype"
                        class="form-item">
                    <Option v-for="item in ethernetypeList"
                            :value="item.id"
                            :key="item.id">{{ item.name }}</Option>
                </Select>
            </FormItem>
            <FormItem :label="`${$t('网络地址')}:`"
                      v-if="formData.authorizationType=='地址段访问'"
                      prop="cidr">
                <InputNumber :max="255"
                             :min="0"
                             style="width: 60px"
                             v-model="formData.cidr0"></InputNumber>
                -
                <InputNumber :max="255"
                             :min="0"
                             style="width: 60px"
                             v-model="formData.cidr1"></InputNumber>
                -
                <InputNumber :max="255"
                             :min="0"
                             style="width: 60px"
                             v-model="formData.cidr2"></InputNumber>
                -
                <InputNumber :max="255"
                             :min="0"
                             style="width: 60px"
                             v-model="formData.cidr3"></InputNumber>
                /
                <InputNumber :max="32"
                             :min="0"
                             style="width: 60px"
                             v-model="formData.cidr4"></InputNumber>
                <Poptip trigger="hover"
                        placement="right"
                        :title="$t('远端地址')">
                    <i class="icon-prompt-1-o tips-style"
                       style="color:#2d8cf0"></i>
                    <div slot="content">
                        {{$t('允许通过该规则的ip地址（CIDR）')}}，<br />{{$t('填写0.0.0.0/0表示允许所有ip地址访问。')}}
                    </div>
                </Poptip>
                <div style="color: #ed4014">{{ cidrErr }}</div>
            </FormItem>
            <FormItem :label="`${$t('描述')}:`">
                <Input v-model="formData.description"
                       type="textarea"
                       :maxlength="225"
                       :autosize=" { minRows: 3, maxRows: 10 }"
                       style="width:660px" />
            </FormItem>
        </Form>
        <div class="submit"
             slot="footer">
            <Button @click="closeModal"
                    type="text"
                    style="margin-left: 8px">{{$t('取消')}}</Button>
            <Button type="primary"
                    @click="handleSubmit">{{title === '创建' ? $t('创建') : $t('保存')}}</Button>

        </div>
    </Modal>
</template>
<script>
import eventBus from '@/service/eventbus.js'
import API from '@/service/api.js'
export default {
    name: 'createrule',
    props: ['ruletype', 'direction', 'vpc'],
    computed: {
        range () {
            let r = ''
            if (this.selectRule.fromPort || this.selectRule.toPort) {
                r = this.selectRule.fromPort + '-' + this.selectRule.toPort
            } else {
                r = '-1--1'
            }
            return r
        }
    },
    data () {
        const validStopPort = (rule, value, callback) => {
            const reg = /^[1-9]+[0-9]*$/
            if (!value) {
                callback(new Error(this.$t('终止端口不能为空')))
            } else if (value < this.formData.fromPorts) {
                callback(new Error(this.$t('终止端口不能小于起始端口')))
            } else if (!reg.test(value)) {
                callback(new Error(this.$t('请输入正整数')))
            } else {
                callback()
            }
        }
        return {
            modalCreate: false,
            comparePort: false,
            startPort: false,
            title: '',
            type: '',
            Credirection: '',
            cidrErr: '',
            envId: '',
            rule: {
                custom: {
                    rule1: {
                        id: 1,
                        name: this.$t('定制TCP规则'),
                        ipProtocol: 'tcp',
                        portRange: false
                    },
                    rule2: {
                        id: 2,
                        name: this.$t('定制UDP规则'),
                        ipProtocol: 'UDP',
                        portRange: false
                    },
                    rule3: {
                        id: 3,
                        name: this.$t('定制ICMP规则'),
                        ipProtocol: 'ICMP',
                        fromPort: '',
                        toPort: '',
                        portRange: false
                    }
                },
                other: {
                    rule1:
                    {
                        id: 4,
                        name: 'ALL ICMP',
                        ipProtocol: 'ICMP',
                        fromPort: '',
                        toPort: '',
                        portRange: true,
                        disPortRange: true
                    },
                    rule2:
                    {
                        id: 5,
                        name: 'ALL TCP',
                        ipProtocol: 'tcp',
                        fromPort: '1',
                        toPort: '65535',
                        portRange: true,
                        disPortRange: true
                    },
                    rule3:
                    {
                        id: 6,
                        name: 'ALL UDP',
                        ipProtocol: 'UDP',
                        fromPort: '1',
                        toPort: '65535',
                        portRange: true,
                        disPortRange: true
                    },
                    rule4:
                    {
                        id: 7,
                        name: 'DNS',
                        ipProtocol: 'UDP',
                        fromPort: '53',
                        toPort: '53',
                        disPortRange: true,
                        portRange: true
                    },
                    rule5:
                    {
                        id: 8,
                        name: 'HTTP',
                        ipProtocol: 'tcp',
                        fromPort: '80',
                        toPort: '80',
                        disPortRange: true,
                        portRange: true
                    },
                    rule6:
                    {
                        id: 9,
                        name: 'HTTPS',
                        ipProtocol: 'tcp',
                        fromPort: '443',
                        toPort: '443',
                        disPortRange: true,
                        portRange: true
                    },
                    rule7:
                    {
                        id: 10,
                        name: 'IMAP',
                        ipProtocol: 'tcp',
                        fromPort: '143',
                        toPort: '143',
                        disPortRange: true,
                        portRange: true
                    },
                    rule8:
                    {
                        id: 11,
                        name: 'IMAPS',
                        ipProtocol: 'tcp',
                        fromPort: '993',
                        toPort: '993',
                        disPortRange: true,
                        portRange: true
                    },
                    rule9:
                    {
                        id: 12,
                        name: 'LDAP',
                        ipProtocol: 'tcp',
                        fromPort: '389',
                        toPort: '389',
                        disPortRange: true,
                        portRange: true
                    },
                    rule10:
                    {
                        id: 13,
                        name: 'MS SQL',
                        ipProtocol: 'tcp',
                        fromPort: '1433',
                        toPort: '1433',
                        disPortRange: true,
                        portRange: true
                    },
                    rule11:
                    {
                        id: 14,
                        name: 'MYSQL',
                        ipProtocol: 'tcp',
                        fromPort: '3306',
                        toPort: '3306',
                        disPortRange: true,
                        portRange: true
                    },
                    rule12:
                    {
                        id: 15,
                        name: 'POP3S',
                        ipProtocol: 'tcp',
                        fromPort: '995',
                        toPort: '995',
                        disPortRange: true,
                        portRange: true
                    },
                    rule13:
                    {
                        id: 16,
                        name: 'POP3',
                        ipProtocol: 'tcp',
                        fromPort: '110',
                        toPort: '110',
                        disPortRange: true,
                        portRange: true
                    },
                    rule14:
                    {
                        id: 17,
                        name: 'RDP',
                        ipProtocol: 'tcp',
                        fromPort: '3389',
                        toPort: '3389',
                        disPortRange: true,
                        portRange: true
                    },
                    rule15:
                    {
                        id: 18,
                        name: 'SMTP',
                        ipProtocol: 'tcp',
                        fromPort: '25',
                        toPort: '25',
                        disPortRange: true,
                        portRange: true
                    },
                    rule16:
                    {
                        id: 19,
                        name: 'SMTPS',
                        ipProtocol: 'tcp',
                        fromPort: '465',
                        toPort: '465',
                        disPortRange: true,
                        portRange: true
                    },
                    rule17:
                    {
                        id: 20,
                        name: 'SSH',
                        ipProtocol: 'tcp',
                        fromPort: '22',
                        toPort: '22',
                        disPortRange: true,
                        portRange: true
                    }
                }
            },
            authorizeList: [
                {
                    name: this.$t('安全组访问'),
                    id: 'security'
                }, {
                    name: this.$t('地址段访问'),
                    id: 'address'
                }
            ],
            securityList: [],
            ethernetypeList: [
                {
                    name: 'IPv6',
                    id: 'IPv6'
                }, {
                    name: 'IPv4',
                    id: 'IPv4'
                }
            ],
            selectRule: {
                id: 1,
                name: this.$t('定制TCP规则'),
                ipProtocol: 'tcp',
                portRange: false
            },
            formData: {
                description: '',
                fromPorts: null,
                toPorts: null,
                authorizationType: '安全组访问',
                ethertype: 'IPv4',
                sourceGroupId: '', // default
                cidr0: null,
                cidr1: null,
                cidr2: null,
                cidr3: null,
                cidr4: null
            },
            ruleForm: {
                fromPorts: [
                    { type: 'string', required: true, message: this.$t('该字段不能为空,且为正整数'), pattern: /^[1-9]+[0-9]*$/, trigger: 'blur' }
                ],
                toPorts: [
                    { validator: validStopPort, type: 'number', trigger: 'blur' }
                ],
                sourceGroupId: [
                    { required: true, message: this.$t('该字段不能为空'), trigger: 'submit' }
                ],
                ethertype: [
                    { required: true, message: this.$t('该字段不能为空'), trigger: 'change' }
                ],
                startPort: [
                    { required: true, type: 'number', message: this.$t('该字段不能为空'), trigger: 'change' }
                ],
                endPort: [
                    { type: 'number', validator: validStopPort, trigger: 'change' }
                ],
                authorizationType: [
                    { required: true, message: this.$t('该字段不能为空'), trigger: 'change' }
                ],
                security: [
                    { required: true, message: this.$t('该字段不能为空'), trigger: 'change' }
                ],
                ethernetype: [
                    { required: true, message: this.$t('该字段不能为空'), trigger: 'change' }
                ]
            }

        }
    },
    created () {
        const that = this
        eventBus.$on('setSecurityId', function (data) {
            that.securityId = data.securityId
            that.envId = data.envId
            that.pId = data.id
        })
    },
    methods: {
        openModal (params) {
            this.$refs.createForm.resetFields()
            this.comparePort = false
            if (params) {
                for (const item in this.rule.custom) {
                    for (const i in this.rule.custom[item]) {
                        if (i === 'ipProtocol') {
                            const ipProtocol = this.rule.custom[item][i]
                            if (params.protocol !== null) {
                                if (ipProtocol.toLowerCase() === params.protocol.toLowerCase()) {
                                    this.selectRule = this.rule.custom[item]
                                }
                            }
                        }
                    }
                }
            }
            this.modalCreate = true
            if (params) {
                this.formData.description = params.description
                this.formData.fromPorts = params.fromPort || (this.selectRule.ipProtocol === 'ICMP' ? 0 : 1)
                this.formData.toPorts = params.toPort || (this.selectRule.ipProtocol === 'ICMP' ? 1 : 2)
                if (this.formData.fromPorts > this.formData.toPorts) {
                    this.comparePort = true
                }
                this.formData.sourceGroupId = null
                this.formData.authorizationType = params.authObj
                if (params.authObj === '安全组访问') {
                    this.formData.ethertype = params.ethertype
                    this.formData.sourceGroupId = params.remoteGroupId
                } else {
                    if (params.remoteIpPrefix) {
                        const ad = params.remoteIpPrefix.split('/')
                        const ipAdress = ad[0].split('.')
                        ipAdress.forEach((r, i) => {
                            this.formData['cidr' + i] = Number(r)
                        })
                        // 解决网络地址(::/0)出现的Nan
                        if (ipAdress.length === 1) {
                            ipAdress.forEach((r, i) => {
                                this.formData['cidr' + i] = null
                            })
                        }
                        this.formData.cidr4 = Number(ad[1])
                    }
                }
            }
            this.getSGList()
        },
        changeSelectRule (item) {
            this.$refs.createForm.resetFields()
            this.selectRule = item
        },
        closeModal () {
            this.formData = {
                description: '',
                fromPorts: null,
                toPorts: null,
                authorizationType: '安全组访问',
                ethertype: 'IPv4',
                sourceGroupId: '', // default
                cidr0: null,
                cidr1: null,
                cidr2: null,
                cidr3: null,
                cidr4: null
            }
            this.selectRule = {
                id: 1,
                name: this.$t('定制TCP规则'),
                ipProtocol: 'tcp',
                portRange: false
            }
            this.handleReset()
        },
        handleReset () {
            this.$refs.createForm.resetFields()
            this.modalCreate = false
        },
        getSGList () {
            const params = { vpc: this.vpc }
            this.axios.get(this.urlFormat(API.GET_SECURITY_GROUPS_NOSELF, false, [this.$route.query.envId, this.$route.query.securityId]), { params }).then(res => {
                this.securityList = res
            })
        },
        handleSubmit () {
            this.$refs.createForm.validate((valid) => {
                this.cidrErr = ''
                let hasCidr = true
                if (this.formData.authorizationType === '地址段访问') {
                    hasCidr = (this.formData.cidr0 || this.formData.cidr0 === 0) && (this.formData.cidr1 || this.formData.cidr1 === 0) && (this.formData.cidr2 || this.formData.cidr2 === 0) && (this.formData.cidr3 || this.formData.cidr3 === 0) && (this.formData.cidr4 || this.formData.cidr4 === 0)
                    !hasCidr && (this.cidrErr = this.$t('该字段不能为空'))
                }
                if (valid && !this.comparePort && hasCidr && !this.startPort) {
                    const p = {
                        id: this.pId,
                        name: this.selectRule.name,
                        fromPorts: !this.selectRule.portRange ? this.formData.fromPorts : this.selectRule.fromPort,
                        toPorts: !this.selectRule.portRange ? this.formData.toPorts : this.selectRule.toPort,
                        direction: this.direction,
                        authorizationType: this.formData.authorizationType,
                        authorizationObj: this.formData.authorizationType === '地址段访问' ? (this.formData.cidr0 + '.' + this.formData.cidr1 + '.' + this.formData.cidr2 + '.' + this.formData.cidr3 + '/' + this.formData.cidr4) : '',
                        ipProtocol: this.selectRule.ipProtocol,
                        ethertype: this.formData.authorizationType === '安全组访问' ? this.formData.ethertype : 'IPv4',
                        description: this.formData.description,
                        // sourceGroupId: this.formData.authorizationType === '安全组访问' ? this.formData.sourceGroupId : this.securityId,
                        sourceGroupId: this.formData.authorizationType === '安全组访问' ? this.formData.sourceGroupId : '' // 非安全组访问为''
                    }
                    this.axios.post(this.urlFormat(API.CREATED_RULE, false), p).then(res => {
                        this.closeModal()
                        this.$emit('refreshTable')
                    })
                    this.modalCreate = false
                    this.handleReset()
                }
            })
        }
    },
    watch: {
        ruletype (newVal, oldVal) {
            this.title = newVal === 'add' ? '创建' : '克隆'
            this.type = newVal
        },
        direction (newVal, oldVal) {
            this.Credirection = newVal
        },
        'formData.fromPorts' (val) {
            val && this.$refs.createForm.validateField('toPorts')
        },
        'selectRule.ipProtocol' (val) {
            if (val) {
                if (val !== 'ICMP' && this.formData.fromPorts <= 0 && this.formData.fromPorts !== null) {
                    this.startPort = true
                } else {
                    this.startPort = false
                }
            }
        }
    }
}
</script>
<style lang="less" scoped>
.securitygroup-form {
    font-family: 'PingFangSC-Light', 'Microsoft YaHei', '宋体', 'Helvetica Neue', Arial, Helvetica, sans-serif;
    .rules-header {
        display: flex;
        .header-left {
            display: inline-block;
            width: 23%;
        }
        .header-right {
            display: inline-block;
            flex: 1;
        }
        .header-title {
            padding-left: 25px;
            font-size: 16px;
        }
        .rule-item {
            display: inline-block;
            background: rgb(228, 243, 241);
            height: 40px;
            width: 130px;
            margin-top: 10px;
            margin-left: 25px;
            line-height: 40px;
            text-align: center;
            font-size: 13px;
            cursor: pointer;
        }
        .active {
            background-color: #3498dc;
            color: white;
        }
    }
    .create-form {
        .form-label {
            display: inline-block;
            width: 48%;
            .form-item {
                width: 230px;
            }
        }
    }
}
</style>
